<template>
  <v-sheet class="overflow-x-auto">
    <div id="chartBarBox" style="height: 45vh" class="sparkline-sheet"></div>
  </v-sheet>
</template>

<style scoped>
@media (max-width: 1199px) {
  .sparkline-sheet {
    width: calc(100vw - 64px);
  }
}
@media (min-width: 1200px) {
  .sparkline-sheet {
    width: calc(100vw - 318px);
  }
}
</style>

<script>
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from "echarts";
import { mapState } from "vuex";

export default {
  name: "BarEcharts",

  props: ["labels", "values", "value"],

  computed: {
    avgNumber() {
      var sum = 0;
      this.values.forEach((item) => {
        sum += item;
      });
      // 均分在九种颜色中
      return this.$numberFormatter.formatTwoDot(sum / this.values.length / 9);
    },
    // itemColor(){

    // },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "showBarEchartsPanel", "primaryDrawer"]),
  },

  data: () => ({
    chartBar: null,
  }),

  mounted() {
    // this.drawBarChart();
  },
  methods: {
    drawBarChart() {
      if (this.chartBar == null) {
        this.chartBar = echarts.init(document.getElementById("chartBarBox"));
      }
      // 指定图表的配置项和数据
      var option = {
        xAxis: {
          data: this.labels,
          axisLabel: {
            show: true,
            interval: 0,
            rotate: -30,
            inside: false,
            margin: 6,
            formatter: "{value}",
            fontSize: "10",
          },
          axisLine: {
            show: true,
          },
        },
        yAxis: {},

        series: [
          {
            type: "bar",
            data: this.values,
            barWidth: "20px",
            itemStyle: {
              color: (params) => {
                var colorList = [
                  "#5470c6",
                  "#91cc75",
                  "#fac858",
                  "#ee6666",
                  "#73c0de",
                  "#3ba272",
                  "#fc8452",
                  "#9a60b4",
                  "#ea7ccc",
                ];
                if (params.data < this.avgNumber) {
                  return colorList[0];
                } else if (params.data < this.avgNumber * 2) {
                  return colorList[1];
                } else if (params.data < this.avgNumber * 3) {
                  return colorList[2];
                } else if (params.data < this.avgNumber * 4) {
                  return colorList[3];
                } else if (params.data < this.avgNumber * 5) {
                  return colorList[4];
                } else if (params.data < this.avgNumber * 6) {
                  return colorList[5];
                } else if (params.data < this.avgNumber * 7) {
                  return colorList[6];
                } else if (params.data < this.avgNumber * 8) {
                  return colorList[7];
                } else {
                  return colorList[8];
                }
              },
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      this.chartBar.setOption(option);
      // 调整图表尺寸
      window.addEventListener(
        "resize",
        function () {
          this.chartBar.resize();
        }.bind(this)
      );
    },
  },
  watch: {
    labels: {
      handler() {
        this.drawBarChart();
      },
    },
    values: {
      handler() {
        this.drawBarChart();
      },
    },
    showBarEchartsPanel: {
      immediate: true,
      handler() {
        clearInterval(this.monitorTime);
        this.monitorTime = setTimeout(
          function () {
            this.drawBarChart();
          }.bind(this),
          1
        );
      },
    },
  },
  beforeDestroy() {
    clearInterval(this.monitorTime);
  },
};
</script>
